import { RtTripDiversion } from '@bds/railtrac-models';
import { RtTripsByRoad } from './rt-trips-by-road.model';

export class RtDiversionDialogModel {
    roads: RtTripsByRoad[] = [];
}
